import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { InvoiceSortField, InvoiceStatus, InvoiceType, SortingOrder } from "@/graphql/codegen/graphql"

export const invoicesSearchParamsSchema = z.object({
  query: fallback(z.string().optional().default(""), ""),

  // Sort — defaults per spec AC #2 (Date Entered descending). Required-with-fallback so the
  // default is applied on first load, not just when the URL contains an invalid value.
  field: fallback(z.nativeEnum(InvoiceSortField), InvoiceSortField.DateEntered),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),

  // Filters — drawer/chips UX shipped by AK-5508.
  statuses: fallback(z.array(z.nativeEnum(InvoiceStatus)).optional(), undefined),
  invoiceType: fallback(z.nativeEnum(InvoiceType).optional(), undefined),
  vendorCompanyId: fallback(z.string().uuid().optional(), undefined),
})

export type InvoicesSearchParams = z.infer<typeof invoicesSearchParamsSchema>
